import { upperFirst } from 'lodash';
// eslint-disable-next-line import/prefer-default-export
export const uppercase = (text) => {
  return `${text}`.toUpperCase();
};

export const sentenceCase = (text) => {
  return upperFirst(`${text}`);
};
